import {ChangeDetectionStrategy, Component, computed, inject, Input, Signal} from '@angular/core';
import {CustomerService} from "../../../shared/services/customer.service";
import {QRCodeComponent} from "angularx-qrcode";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {AppDownloadDialogComponent} from "../app-download-dialog/app-download-dialog.component";
import {ContentComponent} from "../../../shared/elements/content/content.component";

@Component({
    selector: 'app-bar-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    QRCodeComponent,
    TranslatePipe,
    AppDownloadDialogComponent,
    ContentComponent
],
    styleUrl: './bar-footer.component.scss',
    template: `
  @if (showAppDownload && downloadUrl()) {
    <!--<div class="app-store-buttons">
      <div class="app-download-qr">
        <button type="button" class="app-download-button" (click)="appDownloadDialog = true">
          {{ 'GETTHEAPP' | translate }}
        </button>
        <div class="app-download-qr-code">
          <a [href]="downloadUrl()!" target="_blank" rel="noopener noreferrer" aria-label="('APPDOWNLOAD' | translate)">
            <qrcode
              [qrdata]="downloadUrl()!"
              [width]="110"
              [margin]="1"
              [errorCorrectionLevel]="'M'"
              [ariaLabel]="('APPDOWNLOAD' | translate)"
              [alt]="('APPDOWNLOAD' | translate)"
            />
          </a>
        </div>
        <div class="pt-1">
          <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'">{{ "LOGINSCANTODOWNLOADOURAPP" | translate }}</app-content>
        </div>
      </div>
    </div>-->
    <app-app-download-dialog [(visible)]="appDownloadDialog"></app-app-download-dialog>
  }
  `
})
export class BarFooterComponent {
  private customerService: CustomerService = inject(CustomerService);

  @Input() public showAppDownload: boolean = true;
  public appDownloadDialog: boolean = false;

  public downloadUrl: Signal<string | null> = computed(() => {
    const customerKey = this.customerService.customerKey();
    if (!customerKey) {
      return 'https://dl.humanstars.app/downloads';
    }
    return `https://dl.humanstars.app/downloads/${customerKey}`;
  });
}
